import React from "react";
import NoDataMessage from "../NoDataMessage";
import SimpleTable from "./simpleTable";
import KeyValueTable from "./keyValueTable";
import ModalContainer from "../common/Modal/ModalContainer";
import "./style.css";

const Modal = ({ isOpen, onClose, data, text }) => {
    if (!isOpen) return null;
    const hasData = data && Object.keys(data).length > 0;
    return (
        <ModalContainer isOpen={isOpen} onClose={onClose} text={text}>
            {hasData ? (
                Array.isArray(data) ? (
                    <SimpleTable data={data} />
                ) : (
                    <KeyValueTable data={data} />
                )
            ) : (
                <NoDataMessage />
            )}
        </ModalContainer>
    );
};

export default Modal;